export class exclusionMeeting {
  meetingAppealId?;
  meetingDate?;
  meetingTime?;
  meetingDateTime?;
  meetingDateMsg?;
  meetingStatus?;
  decisionResult?;
  officerAttendingName?;
  carersAttended?;
  carersAttendedFlag?;
  pupilAppellant?;
  pupilAppellantFlag?;
  meetingType?;
  meetingTypeInfo?;
  senExpertAttended?;
  senExpertAttendedFlag?;
  senExpertAttendedDetails?;
  requestedDate?;
  senExpertRevReq?;
  SENExpertRevReqMsg?;
  appealMeetingRequestMsg?;
  meetingAttendees?;
  reinstatementDate?;
  reinstatementReason?;
}

export enum ExclusionMeetingEnum {
  Meeting = 'Governing',
  Appeal = 'Appeal'
}

export const meetingTypeCollection = [
  {
    value: ExclusionMeetingEnum.Meeting,
    description: 'Governing body/committee meeting'
  },
  { value: ExclusionMeetingEnum.Appeal, description: 'Appeal meeting' }
];
